(function(window, document) {
	/* ----------------------------------- [START] Setting */
	/* 取得裝置判斷 */
	var isMobile = false;
	var deviceDetect = function () {
		/* IsMobile */
		/* 防止測試時一直用開發者工具Resize出現Bug */
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}
	deviceDetect();
	registerListener('resize', throttle(deviceDetect, 50, 100));
	/* ----------------------------------- [END] Setting */
	/*
		* 左欄 Banner
		*/
	var pdBanner__target = '#product-aside-banner-carousel';
	var pdBanner__swiper = undefined;
	var pdBanner__swiperBuild = function() {
		var swiperTarget = pdBanner__target,
			swiperTargetEl = document.querySelector(swiperTarget);
		if (swiperTargetEl === null) return false;
		var swiperEl = swiperTargetEl.parentElement,
			swiperPageEl = swiperEl.querySelector('.swiper-pagination');
		pdBanner__swiper = new Swiper(swiperTarget, {
			spaceBetween: 10,
			autoplay: {
				delay: 5000,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: '上一項',
				nextSlideMessage: '下一項',
				firstSlideMessage: '第一項',
				lastSlideMessage: '最後一項',
				paginationBulletMessage: '去第{{index}}項'
			},
			lazy: true,
			loop: true,
			pagination: {
				el: swiperPageEl,
				clickable: true
			}
		});
	}
	var pdBanner__imgLoad = function () {
		var target = $(pdBanner__target).find('img');
		for(var i = 0; i < target.length; i++) {
			var currentImg = target.eq(i);
			var src = currentImg.attr('data-src');
			if (src=== undefined) break;
			currentImg.attr('src', src);
			currentImg.addClass('swiper-lazy-load');
			currentImg.removeAttr('data-src');
		}
	}
	var pdBanner__breakpoint = window.matchMedia('(min-width: 640px)');
	var pdBanner__breakpointChecker = function() {
		if(pdBanner__breakpoint.matches) {
			if(pdBanner__swiper !== undefined) pdBanner__swiper.destroy(true, true);
			else pdBanner__imgLoad();
		} else {
			pdBanner__swiperBuild();
		}
	}
	registerListener('load', function () {
		if (document.querySelector('#product-aside-banner-carousel') !== null) {
			pdBanner__breakpointChecker();
			pdBanner__breakpoint.addListener(pdBanner__breakpointChecker);
		}
	});
	/* --------------------------------------- */
	/*
		* Fixed Panel M (螢幕 < 640 才有樣式)
		*/
	/* 配合樣式： .fixed-panel-m 使用
	 * 外層： data-fixed-panel
	 * 開啟按鈕：data-panel-open
	 * 關閉按鈕：data-panel-close
	 * 手機板固定介面(panel)：data-panel
	 */
	var buildFixedPanel = function() {
		$('[data-fixed-panel]').each(function () {
			var fixedPanel = $(this),
				panel = fixedPanel.find('[data-panel]'),
				openBtn = fixedPanel.find('[data-panel-open]'),
				closeBtn = fixedPanel.find('[data-panel-close]'),
				type = fixedPanel.attr('data-layout'),
				openClass = 'is-open';
			openBtn.on('click', function () {
				if(window.innerWidth < 1024) {
					panel.addClass(openClass);
					docDisableScroll();
				} else {
					if(!isMobile && type === 'compare') { return false }
					fixedPanel.toggleClass(openClass);
					panel.toggleClass(openClass);
				}
			});
			closeBtn.on('click', function () {
				panel.removeClass(openClass);
				if(window.innerWidth < 1024) {
					docEnableScroll();
				} else {
					fixedPanel.removeClass(openClass);
				}
			});
		});
	}
	registerListener('load', buildFixedPanel);
	/* --------------------------------------- */
	/*
		* Filter
		*/
	/* List Nav 開啟/關閉 (Mobile) */
	var buildPdListNavPanel = function() {
		$('[data-fixed-panel][data-layout="aside"]').each(function () {
			var pdListNav = $(this),
				openBtn = pdListNav.find('[data-panel-open]');
			openBtn.on('click', function () {
				if(priceSliderEl !== undefined && priceSliderEl.length > 0) priceRangeResetFill();
			});
		});
	}
	registerListener('load', buildPdListNavPanel);
	/* --------------------------------------- */
	/* 價格 (連動選單不在這，在下方) */
	var priceRangeEl = $('#filter-price');
	var priceSliderEl = priceRangeEl.find('.filter-price__slider');
	var priceSliderData = null; // 紀錄 Foundation Slider 數值
	var priceSliderDataOption = null;
	
	/* 取得最小值&最大值 */
	var priceRangeMin = priceSliderEl.attr('data-start') || 0;
	var priceRangeMax = priceSliderEl.attr('data-end') || 0;
	var priceRangeMaxInit = (priceRangeMax * 1).toString() || 0; // 起始預設

	/* 取得綁定值物件(input) */
	var priceRangeMinEl = document.querySelector('#filter-price-min');
	var priceRangeMaxEl = document.querySelector('#filter-price-max');

	/* 顯示文字物件 */
	var priceViewMin = priceRangeEl.find('.filter-price__min');
	var priceViewMax = priceRangeEl.find('.filter-price__max');

	/* 是否有更改值 */
	// var priceRangeChanged = priceSliderEl.attr('data-changed') === 'true' || false;
	var priceGetChangeHandler = function priceGetChangeHandler() {
		return (priceRangeMin !== parseFloat(priceRangeMinEl.value) || priceRangeMaxInit !== parseFloat(priceRangeMaxEl.value))
	}
	var priceRangeChanged = false;
	var priceRangeChangedOld = null; // 紀錄舊值

	priceSliderEl.removeAttr('data-changed');

	/* 價格 - 將價格文字格式化 */
	var priceFormat = function(priceNum) {
		return priceNum.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ',')
	}

	/* 價格 - 價格更改預設值 */
	var priceDefaultSet = function(min, max) {
		priceRangeMin = min;
		priceRangeMax = max;
		priceRangeMaxInit = max;

		// 更改篩選 Input 值
		priceRangeMinEl.value = min;
		priceRangeMaxEl.value = max;

		// 更改 篩選值 設定
		priceSliderEl.attr({
			'data-start': min,
			'data-initial-start': min,
			'data-end': max,
			'data-initial-end': max
		});
	}

	/* 價格 - 顯示最大值與最小值「文字」 */
	var priceRangeShow = function() {
		priceViewMin.text(priceFormat(priceRangeMinEl.value));
		priceViewMax.text(priceFormat(priceRangeMaxEl.value));
	}

	/* 價格 - 挪動後的事件 */
	var priceSliderMove = function () {
		if (priceGetChangeHandler()) priceRangeChanged = true;
		priceRangeShow();
		priceFilterCheck();
	}

	/* 價格 - 重設顯示上的Range */
	var priceRangeResetFill = function () {
		priceSliderEl.foundation('_reflow');

		/* 因為Foundation會誤算fill值，所以手動重設 */
		setTimeout(() => {
			var rangeMin = priceRangeMinEl.value;
			var rangeMax = priceRangeMaxEl.value;
			var fillMinWidth = Math.round((rangeMax - rangeMin) / (priceRangeMax - priceRangeMin) * 10000) / 100;
			priceSliderData.$fill.eq(0).css('min-width', fillMinWidth +'%');
		}, 300);
	}

	/* 價格 - 重設最大最小值為預設 */
	var priceRangeReset = function() {
		if(priceRangeMinEl === null) return false;
		priceRangeMinEl.value = priceRangeMin;
		priceRangeMaxEl.value = priceRangeMaxInit;
		priceRangeResetFill();
	}

	/* 價格 - init，建立價格篩選 */
	var priceRangeBuild = function() {
		if(priceSliderEl.length > 0) {
			/* 設定預設值為其餘 function: priceDefaultSet() */
			priceSliderData = new Foundation.Slider(priceSliderEl);
			priceSliderDataOption = priceSliderData.options;
			priceSliderEl.on('moved.zf.slider', priceSliderMove);

			priceRangeChanged = priceGetChangeHandler(); // 重新取得 input value 值
		}
	}
	
	/* 價格 - START */
	// 因為順序上建立的問題，併到下方 連動選單 > 4. 綁定價格 才啟動
	// registerListener('load', priceRangeBuild);
	/* --------------------------------------- */
	/* Checkbox Filter (連動選單不在這，在下方) */
	var resetGlobal = $('.product-list-filter-reset-global');
	var resetGlobalM = $('.product-list-filter-reset-global--m');
	var resetGlobalMClassDisabled = 'disabled';
	var resetArea = $('.product-list-filter-reset-area');
	var resetGlobalShow = false;
	var checkboxFilterSelect = []; // 紀錄分類是否是關閉
	var checkboxFilter = $('.product-list-filter-panel');
	var checkboxFilterGroup = $('.product-list-filter-panel__item');
	var checkboxFilterTarget = checkboxFilter.find('.accordion-content');
	var checkboxFilterTip = checkboxFilter.find('.product-list-filter-panel__tip');
	var checkboxFilterHideClass = 'hide';
	var checkboxFilterOpenCache = null;
	var checkboxFilterTimer = null;

	/* 已篩選時，顯示的提示文字 */
	var filterTip = $('.fixed-panel-m__btn__tip');
	var filterTipText = '（已篩選）';

	/* Filter Panel - 重設整區(PC) */
	var resetGlobalStatus = function () {
		if(resetGlobalShow) {
			/* 有值 */
			resetGlobal.slideDown();
		} else {
			/* 無值 */
			resetGlobal.slideUp();
		}
	}

	/* Filter Panel - 重設整區(Mobile) */
	var resetGlobalMStatus = function () {
		if(resetGlobalShow || priceRangeChanged) {
			/* 有值 */
			resetGlobalM.removeClass(resetGlobalMClassDisabled);
			filterTip.text(filterTipText);
		} else {
			/* 無值 */
			resetGlobalM.addClass(resetGlobalMClassDisabled);
			filterTip.text('');
		}
	}

	/* Checkbox - 確認所有 Checkbox 有無值 => 重設整區 */
	var checkboxFilterCheckAllValue = function() {
		resetGlobalShow = checkboxFilterSelect.some(function(value) {
			return value
		});
		resetGlobalStatus();
		resetGlobalMStatus();
	}

	/* 價格 - 確認有無變動 => 重設整區 */
	var priceFilterCheck = function () {
		if(priceRangeChangedOld !== priceRangeChanged) {
			priceRangeChangedOld = priceRangeChanged;
			resetGlobalStatus();
			resetGlobalMStatus();
		}
	}

	/* Checkbox - 手動重設 Checkbox 項目為 false
	 * 清除全部時 button[type="reset"] 的功用是重設預設值，導致原本設置checked="true"的物件被重設為true
	 * 因此清除全部時要跟著清除 Attribute，避免上述情況
	 */
	var resetFilterItemAll = function() {
		checkboxFilterGroup.each(function(index, el) {
			var checkbox = $(el).find('input[type="checkbox"]');
			checkbox.removeAttr('checked');

			/* 重設計算 */
			el.checkboxFilter.count = 0
		})
	}

	/* Checkbox - 重設選項 */
	var resetGlobalClickHandler = function () {
		resetFilterItemAll();
		if (checkboxFilter.length) {
			checkboxFilter.foundation('up', checkboxFilterTarget);
		}
		checkboxFilterOpenCache = null;
		for(var i = 0; i < checkboxFilterSelect.length; i++) {
			checkboxFilterSelect[i] = false;
			if(i === checkboxFilterSelect.length - 1) {
				checkboxFilterCheckAllValue();
				resetArea.slideUp(checkboxFilterHideClass);
				checkboxFilterTip.slideDown();
			}
		}
	}

	/* Filter Panel - 點擊重設(PC) */
	resetGlobal.on('click', resetGlobalClickHandler);
	
	/* Filter Panel - 點擊重設(Mobile) */
	resetGlobalM.on('click', function() {
		if(!resetGlobalM.hasClass(resetGlobalMClassDisabled)) {
			priceRangeChanged = false;
			priceRangeReset();
			resetGlobalClickHandler();
		}
	});

	/* ----------------------------------- */
	/* 針對各別分類的動作
	 * 取消該項目的所有Checkbox
	 */
	var resetItemCheckbox = function(parentElement, checkbox) {
		checkbox.each(function (index, el) {
			el.checked = false;
			el.removeAttribute('checked');
			if(index === checkbox.length - 1) {
				if(checkboxFilterTimer !== null) clearTimeout(checkboxFilterTimer);
				checkboxFilterTimer = setTimeout( function() {
					checkboxFilterTimer = null;
					checkValue(parentElement);
					checkboxFilterCheckAllValue();
				}, 50);
			}
		});
	}

	/* 確認該分類的項目的Checked狀況 */
	var checkValue = function(el, hasCheckedParam) {
		var elCheckboxFilter = el.checkboxFilter;
		var self = elCheckboxFilter.$el,
			reset = elCheckboxFilter.$reset,
			index = elCheckboxFilter.index;
		var hasChecked = hasCheckedParam || self.find('input[type=checkbox]:checked').length > 0;

		elCheckboxFilter.count = self.find('input[type=checkbox]:checked').length;

		if(hasChecked) {
			/* 已有選擇 */
			reset.slideDown(checkboxFilterHideClass);
			checkboxFilterSelect[index] = true;
		} else {
			reset.slideUp(checkboxFilterHideClass);
			checkboxFilterSelect[index] = false;
		}
	}
	/* ----------------------------------- */

	/* Checkbox - init */
	var buildCheckboxFilter = function () {
		checkboxFilterGroup.each(function(index, el) {
			var self = $(el);
			var reset = self.find('.product-list-filter-reset-area');
			var checkbox = self.find('input[type="checkbox"]');
			var count = self.find('.product-list-filter-panel__count');
			var countNum = self.find('.product-list-filter-panel__count-number');

			/* 記錄在物件上 */
			if(el.checkboxFilter === undefined) {
				el.checkboxFilter = {
					$el: self,
					$reset: reset,
					$checkbox: checkbox,
					$count: count,
					$countNum: countNum,
					index: index
				}

				Object.defineProperty(el.checkboxFilter, 'count', {
					get: function() {
						return parseInt(this.$countNum.text())
					},
					set: function (newVal) {
						this.$countNum.text(newVal)
						if (newVal === 0) {
							this.$count.addClass('hide')
						} else {
							this.$count.removeClass('hide')
						}
					}
				});
			}

			checkboxFilterSelect.push(false);

			var checkInit = function() {
				var hasChecked = self.find('input[type=checkbox]:checked').length > 0;
				checkValue(el, hasChecked);
				if(hasChecked) {
					/* 已有選擇 */
					var $target = self.find('.accordion-content').eq(0);
					checkboxFilter.foundation('down', $target);
					checkboxFilterOpenCache = el;
				} else if(self.hasClass('is-active')) {
					/* 如果有 "is-active" => 代表選擇全部 */
					checkboxFilterSelect[index] = true;
					checkboxFilterOpenCache = el;
				}
			}

			/* Start */
			checkInit();
			if(index === checkboxFilterGroup.length - 1) checkboxFilterCheckAllValue();

			/* Checkbox Change Event */
			checkbox.on('change', function() {
				checkValue(el);
				checkboxFilterCheckAllValue();
			});

			/* 清除選取 */
			reset.on('click', function() {
				resetItemCheckbox(el, checkbox);
			});
		});
	}
	registerListener('load', buildCheckboxFilter);

	/* --------------------------------------- */
	/* --------------------------------------- */
	/* --------------------------------------- */
	/* [START] 連動選單 */
	/* ※避免客戶未來有可能後悔不要用純前端計算改用API，連動部分與原操作項目分開寫★★★★★★
	 *
	 * 商品紀錄（Filter使用）
	 */
	var checkboxFilterList = $('.product-list-filter');
	var pdCount = $('.product-list-group__title span'); // 「共 『N』 件商品」物件
	var checkboxFilterEnable = checkboxFilterList.length !== 0; // 判斷是否有 Checkbox 篩選
	var priceFilterEnable = $('.solid-shadow__item .price').length > 1; // 判斷是否有 價格 篩選
	var priceFilterSet = { min: null, max: null } // 價格 - 紀錄最小值與最大值
	var filterName = []; // 紀錄有多少filter大項
	var pdList = []; // 紀錄整理後的列表
	var pdListCate = {}; // 紀錄分類後的列表
	var pdListPrice = []; // 價格 - 紀錄頁面上所有的價格

	var filterSelected = {}; // Checkbox有選擇的項目
	var filterResult = []; // 要顯示的項目



	/* ----------------------------------------------------------- [START] Tool */
	/* 大寫第一個字：https://stackoverflow.com/a/1026087/11240898 */
	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	function capitalizeFirstLetterDash(string) {
		var stringSplit = string.split('-');
		var result = '';
		for(var i = 0; i < stringSplit.length; i++) {
			result += capitalizeFirstLetter(stringSplit[i])
		}
		return result;
	}

	/* -------------- */
	/* 合併Array */
	/* https://stackoverflow.com/a/45381838/11240898 */
	function flatten(arr) {
		var flat = [];
		for (var i = 0; i < arr.length; i++) {
			flat = flat.concat(arr[i]);
		}
		return flat;
	}

	/* 比對兩Array是否有重複 */
	/* https://stackoverflow.com/a/12433654/11240898 */
	Array.prototype.diff = function(arr2) {
		var ret = [];
		this.sort();
		arr2.sort();
		for(var i = 0; i < this.length; i += 1) {
			if(arr2.indexOf(this[i]) > -1){
				ret.push(this[i]);
			}
		}
		return ret;
	};
	/* ----------------------------------------------------------- [END] Tool */



	/* --------------------------------------------- [START] 操作列表 */
	/* 列表全顯示/隱藏 */
	var pdItemHideClass = "hide";

	/* 顯示全部 */
	var pdListAllShow = function(callback) {
		for(var i = 0; i < pdList.length; i++) {
			pdList[i].el.classList.remove(pdItemHideClass)
		}

		showListCount(pdList.length)

		if(typeof callback === 'function') {
			callback();
		}
	}

	/* 隱藏全部 */
	var pdListAllHide = function(callback) {
		for(var i = 0; i < pdList.length; i++) {
			pdList[i].el.classList.add(pdItemHideClass)
		}

		if(typeof callback === 'function') {
			callback();
		}
	}

	/* 顯示部分列表 */
	var pdListPartShow = function(list) {
		for(var i = 0; i < list.length; i++) {
			list[i].el.classList.remove(pdItemHideClass)
		}

		showListCount(list.length)
	}
	// var pdListPartHide = function(list) {
	// 	for(var i = 0; i < list.length; i++) {
	// 		list[i].el.classList.add(pdItemHideClass)
	// 	}
	// }

	/* 顯示「共 『N』 件商品」 */
	var showListCount = function(length) {
		if (pdCount.length > 0) {
			pdCount.text(length)
		}
	}

	/* 確認是否有選擇項目（範圍：全部） */
	var filterSelectedCheck = function() {
		var hasChecked = false;
		for(var i = 0; i < filterName.length; i++) {
			if (filterSelected[filterName[i].name].length > 0) {
				hasChecked = true;
				break;
			}
		}
		return hasChecked
	}

	/* 篩選符合項目的物件(僅Checkbox) */
	var pdListFilterShowList = function() {
		/* 1. 先找最開始有項目的（依照頁面上的順序） */
		var startIndex = null; // 最開始有項目的篩選分類 序數
		var startName = null; // 最開始有項目的篩選分類 name
		for (var i = 0; i < filterName.length; i++) {
			if (filterSelected[filterName[i].name].length > 0) {
				startIndex = i;
				startName = filterName[i].name;
				break;
			}
		}

		/* 2. 快取已選擇項目(最開始有項目的篩選分類) */
		var currentFilterSelected = filterSelected[startName];
		var currentPdListCate  = pdListCate[startName];
		var arrays = [];
		for (var i = 0; i < currentFilterSelected.length; i++) {
			var current = currentPdListCate[currentFilterSelected[i]];
			if(current !== undefined) {
				arrays.push(current)
			}
		}
		var filterResultCache = flatten(arrays); // 最開始有項目的篩選分類 的 選擇物件

		/* 3. 開始篩選其他分類（非最後一個項目）*/
		if (startIndex !== filterName.length - 1) {
			for (var i = startIndex + 1; i < filterName.length; i++) {
				if (filterSelected[filterName[i].name].length > 0) {
					/* 選項大於1項才繼續*/
					filterResultCache = filterResultCache.filter(item => {
						/* 比對兩個Array（商品的Array與選擇的篩選Array）*/
						var diff = item[filterName[i].dataKey].diff(filterSelected[filterName[i].name]);
						return diff.length > 0
					});
				}
			}
		}

		/* 符合Checkbox篩選的項目 */
		return filterResultCache;
	}

	/* 金額篩選 */
	var priceFilterShowList = function(list) {
		list = list.filter(item => {
			return item.price === null || (item.price >= priceValue.min && item.price <= priceValue.max)
		});
		return list
	}

	/* 進行篩選(Checkbox篩選→價格篩選→顯示結果) */
	var priceRangeMinNumber = parseInt(priceRangeMin); // 價格設定type轉換為數字
	var priceRangeMaxNumber = parseInt(priceRangeMax); // 價格設定type轉換為數字
	var showFilterResult = function() {
		if (filterSelectedCheck()) {
			/* 有選擇項目 */
			/* 0. 先隱藏全部 */
			pdListAllHide();

			/* 1. 篩選Checkbox */
			filterResult = pdListFilterShowList();

			/* 2. 篩選價格 */
			var filterResultPrice = priceFilterShowList(filterResult);

			/* 3. 顯示結果 */
			pdListPartShow(filterResultPrice);
		} else if (priceValue.min !== priceRangeMinNumber || priceValue.max !== priceRangeMaxNumber) {
			/* 如果沒有選擇，但有選擇價格 */
			/* 0. 先隱藏全部 */
			pdListAllHide();

			/* 1. 篩選價格 */
			var filterResultPrice = priceFilterShowList(pdList);

			/* 2. 顯示結果 */
			pdListPartShow(filterResultPrice);
		} else {
			/* 如果沒有選擇 && 金額範圍是全部 => 顯示全部 */
			pdListAllShow()
		}

		/* Lazy load */
		window.imglazyload()
	}
	/* --------------------------------------------- [END] 操作列表 */



	/* 1. 取得 filter 大項名稱(Checkbox) */
	var filterNameGet = function () {
		if (!checkboxFilterEnable) { return false }
		checkboxFilterList.each(function(index, item) {
			var currentFilterName = item.dataset.filter;
			var result = {
				name: currentFilterName,
				dataKey: 'filter' + capitalizeFirstLetterDash(currentFilterName)
			};
			filterName.push(result);
		});

		/* 為每個項目新增Object */
		for(var i = 0; i < filterName.length; i++) {
			pdListCate[filterName[i].name] = {};
			filterSelected[filterName[i].name] = [];
		}
	}



	/* -------------- */
	/* 2. 整理頁面列表 */
	var pdListBuild = function() {
		var pdListGroup = $('[data-layout="product-list"]');
		var pdListItem = pdListGroup.children('li');

		pdListItem.each(function(index, item) {
			var $el = $(item);

			var value = {
				el: item,
				$el: $el,
				price: parseInt($el.find('.price__new').text().replace(/[$,]/g, '')) || null,
			}

			if (checkboxFilterEnable) {
				for(var i = 0; i < filterName.length; i++) {
					/* 尋找是否有符合名稱的filter(例如：尺寸(size)為data-filter-size="XXX") */
					/* ↓XXX值 */
					var currentFilter = item.dataset[filterName[i].dataKey];
					if (currentFilter !== undefined) {
						/* 確認有值 */

						/* 大項目值 size, type, rule-a之類 */
						var currentFilterName = pdListCate[filterName[i].name];

						/* 讓資料可以複選(data-filter-xxx="A,B")，複數值中間使用逗號 */
						var currentFilterSplit = currentFilter.split(',');
						for (var j = 0; j < currentFilterSplit.length; j++) {
							/* 刪除前後空白 */
							var currentFilterSplitItem = currentFilterSplit[j].trim();

							/* 避免逗號後沒資料 */
							if (currentFilterSplitItem === '') { continue }
							
							/* 確認是否已經建立Array => 沒有 => 建立新Array */
							if (currentFilterName[currentFilterSplitItem] === undefined) { 
								currentFilterName[currentFilterSplitItem] = []
							}

							/* 推資料 */
							currentFilterName[currentFilterSplitItem].push(value);
						}

						/* value紀錄filter */
						value[filterName[i].dataKey] = currentFilterSplit;
					}
				}
			}

			pdList.push(value);

			/* 紀錄價格 */
			value.price && pdListPrice.push(value.price);
		});

		filterResult = pdList;

	}



	/* -------------- */
	/* 3. 綁定checkbox */
	var checkboxEl = document.querySelectorAll('.product-list-filter__checkbox');
	var checkboxValue = {}; // 設定所有 Checkbox 的 defineProperty
	var checkboxValueTimer = null;
	var checkboxValueBuild = function() {
		if (!checkboxFilterEnable) { return false }
		[].forEach.call(checkboxEl, function(item, index) {
			checkboxValue[item.id] = {}
			var value = item.value;
			var filterName = item.parentElement.parentElement.dataset.filter;
			Object.defineProperty(checkboxValue[item.id], 'value', {
				get: function() { return item.checked; },
				set: function(newValue) { 
					if (newValue) {
						/* 紀錄目前有選擇的項目 */
						filterSelected[filterName].push(value);
					} else {
						/* 移除有選擇的項目 */
						var itemIndex = filterSelected[filterName].indexOf(value);
						if (itemIndex > -1) {
							filterSelected[filterName].splice(itemIndex, 1);
						}
					}

					if (checkboxValueTimer !== null) { clearTimeout(checkboxValueTimer)}
					checkboxValueTimer = setTimeout(() => {
						showFilterResult()
					}, 100);
				}
			});
			item.addEventListener('change', function() {
				var _this = this;
				checkboxValue[_this.id].value = _this.checked;
			});
		});
	}
	

	/* -------------- */
	/* 4. 處理 & 綁定價格 */
	var priceValue = {}
	var priceValueBuild = function () {
		if (priceRangeEl.length > 0 && priceFilterEnable) {
			/* 價格篩選：有啟動之情況 */

			/* 處理價格 */
			priceFilterSet.min = Math.min(...pdListPrice);
			priceFilterSet.max = Math.max(...pdListPrice);

			/* 如果最大跟最小值相同，則最小設為 0 */
			if (priceFilterSet.min === priceFilterSet.max) {
				priceFilterSet.min = 0
			}

			/* 更改預設值 */
			priceDefaultSet(priceFilterSet.min, priceFilterSet.max);

			/* 建立價格篩選，啟動 Slide */
			priceRangeBuild();

			Object.defineProperties(priceValue, {
				'min': {
					get: function() { return parseInt(priceRangeMinEl.value) },
					set: function() {
						showFilterResult()
					}
				},
				'max': {
					get: function() { return parseInt(priceRangeMaxEl.value) },
					set: function() {
						/* ※因為大小值都會設置，只要將事件綁在min上，有get就不能沒有set，所以set留著 */
						/* 用其它的value設定讀取會有延遲，原因不明 */
						// showFilterResult()
					}
				}
			});

			var priceMoveHandler = function() {
				priceValue.min = parseInt(priceRangeMinEl.value);
				priceValue.max = parseInt(priceRangeMaxEl.value);
			}
			if(priceSliderEl.length > 0) {
				priceSliderEl.on('changed.zf.slider', priceMoveHandler);
			}
		} else {
			/* 價格篩選：無啟動 */
			/* 隱藏區塊 */
			priceRangeEl.parent().parent().addClass('hide');
		}
	}




	/* -------------- */
	/* 5. 進行 checkbox 的共同處理區 */
	var checkboxAndPriceCheck = function() {
		if (!checkboxFilterEnable && !priceFilterEnable) {
			/* 如果同時沒有 checkbox 與 價格篩選 */
			$('.fixed-panel-m.filter').addClass('hide');
		}
	}



	/* -------------- */
	/* 6-1. 清除全部（區域範圍） */
	var filterResetArea = function(event) {
		var filterName = event.target.nextElementSibling.dataset.filter;
		filterSelected[filterName] = []
		showFilterResult();
	}

	/* 6-2. 清除全部（全範圍） */
	var filterResetAll = function() {
		for (var i = 0; i < filterName.length; i++) {
			filterSelected[filterName[i].name] = []
		}
		showFilterResult();
	}



	/* -------------- */
	/* 7-1. 讀取/儲存快取 */
	/* 設定於 sessionStorage ：只存留在相同分頁
	 * 進入頁面：讀取→刪除→比對頁面、時間→給值→設定showList
	 * 離開頁面：儲存
	 */
	var storageKey = 'pdListFilter';
	var storageSave = function() {
		var value = {
			time: new Date().getTime(),
			href: location.href,
			priceMin: priceRangeMin !== priceRangeMinEl.value ? parseInt(priceRangeMinEl.value) : null,
			priceMax: priceRangeMax !== priceRangeMaxEl.value ? parseInt(priceRangeMaxEl.value) : null,
			filter: filterSelected
		}
		sessionStorage.setItem(storageKey, JSON.stringify(value));
	}

	var storageCheck = function() {
		var cacheData = sessionStorage.getItem(storageKey) || null;
		if ( cacheData === null ) { return false }

		cacheData = JSON.parse(cacheData);

		var currentTime = new Date().getTime();
		var currentLocationHref = location.href;
		var timeStandard = 2000; // 判斷基準 2 秒


		if (currentLocationHref === cacheData.href && currentTime - cacheData.time < timeStandard) {
			/* 符合資格：同樣頁面、時間差1秒內 */

			/* 設定價格 */
			if(priceFilterEnable && (cacheData.priceMin || cacheData.priceMax)) {
				if(cacheData.priceMin) { priceRangeMinEl.value = cacheData.priceMin; }
				if(cacheData.priceMax) { priceRangeMaxEl.value = cacheData.priceMax; }
				priceRangeResetFill();
			}

			/* 設定篩選 */
			if(filterName[0]) {
				for(let i = 0; i < filterName.length; i++) {
					var currentFilter = cacheData.filter[filterName[i].name];
					var filterGroup = $(`.product-list-filter[data-filter="${filterName[i].name}"]`);
					for (var j = 0; j < currentFilter.length; j++) {
						var target = filterGroup.find(`input[value="${currentFilter[j]}"]`).get(0);
						target.checked = true;
						checkboxValue[target.id].value = true;

						/* Last */
						if (j === currentFilter.length -1 ){
							checkValue(filterGroup.parents('.product-list-filter-panel__item').get(0))
						}

					}

					/* Last */
					if ( i === filterName.length - 1 ) {
						checkboxFilterCheckAllValue()
					}
				}
			}
		}

		/* 刪除紀錄 */
		sessionStorage.removeItem(storageKey);
	}

	var storageBuild = function() {
		/* 讀取紀錄 */
		storageCheck();

		var eventName = isMobile ? 'pagehide' : 'beforeunload';

		/* 離開前紀錄 */
		/* beforeunload: Mobile不支援，支援 unload */
		window.addEventListener(eventName, function (event) {
			if (priceRangeMinEl !== null && priceRangeMaxEl !== null) {
				storageSave();
			}
		});
	}

	/* --------------*/
	/* Init*/
	var filterBindContent = function() {
		/* 1. 取得 filter 大項名稱(Checkbox)*/
		filterNameGet();

		/* 2. 整理頁面列表*/
		pdListBuild()

		/* 3. 綁定checkbox*/
		checkboxValueBuild();

		/* 4. 處理 & 綁定價格*/
		/* 因為一開始會觸發一次Move，重算位置，所以延遲生成*/
		priceValueBuild();
		setTimeout(() => {
			storageBuild();
		}, 200);

		/* 5. 進行 checkbox 的共同處理區 */
		checkboxAndPriceCheck();

		/* 6-1. 清除全部（區域範圍）*/
		resetArea.on('click', filterResetArea);

		/* 6-2. 清除全部（全範圍）*/
		resetGlobal.on('click', filterResetAll);
		resetGlobalM.on('click', filterResetAll);

	}

	registerListener('load', filterBindContent);




	



	/* ※避免客戶未來有可能後悔不要用純前端計算改用API，連動部分與原操作項目分開寫★★★★★★ */
	/* [END] 連動選單 */
	/* --------------------------------------- */
	/* --------------------------------------- */
	/* --------------------------------------- */

	/*
		* 提醒(複製內容 & 放置於頁面尾端)
		*/
	var pdTip = $('.product-list-nav__tip');
	if(pdTip.length > 0) {
		var pdTipCopy = pdTip.clone();

		pdTip.addClass('hide-for-small-only');

		pdTipCopy.addClass('show-for-small-only');
		$('.layout-lr__cont').append(pdTipCopy);
	}
	
	/* --------------------------------------- */
	/*
		* Compare List & Product List
		*/
	var compareGroupCache = {},

		$productWrapper = $('.product-list-wrapper'),
		$productItem = $productWrapper.find('[data-product-id]').not('[data-compare="false"]'),
		$productItemCompareFalse = $productWrapper.find('[data-compare="false"]'),
		$compareGroup = $('.product-list-group'),

		$compareNavWrapper = $('#compare-nav-wrapper'),
		$compareNavNum = $compareNavWrapper.find('.num'),
		$compareNavBtnSubmit = $compareNavWrapper.find('.compare-submit'),
		$compareNavBtnWrapper = $compareNavBtnSubmit.parent(),
		$compareNav = $('#compare-nav'),

		compareNavClassHide = 'hide',
		compareNavBtnClassHide = 'disabled',
		comparedWrapperClassIsAdded = 'is-added', // <li>外框使用
	
		compareArray = [], // 紀錄比較清單
		compareCurrentGroup = '', // 確認是否已有比較項目(Group名稱)
		$compareCurrentGroupEl = null, // 紀錄目前正比較的GroupList
		compareReInit = false, // 是否從 0 -> 1 
		compareMax = 4; // 比較數量 最大值

	/**
	 * 回傳 <label> 顯示文字
	 * @param {boolean} value - 輸入 [ null | true | false ]
	 * @param {boolean} theSame - 是否為同一個Group，預設為false，輸入 [ true | false ]
	 * @returns {string} 輸出.label [ 無法比較 | 已加入比較 | 加入比較 ]
	 * @returns {string} 輸出.tip [ 比較數量已達上限 | 非同類型無法比較 | 至多選擇 4 個產品進行比較 ]
	 */
	var compareCheckboxLabelTextGet = function(value, theSame = false) {
		var result = {
			label: value === null ? '無法比較' : value ? '已加入比較' : '加入比較',
			tip: value === null ? theSame ? '比較數量已達上限' : '非同類型無法比較' : '至多選擇 4 個產品進行比較'
		}
		return result
	}

	/**
	 * 比較Checkbox確認
	 * @param {string} status - 類型，預設為"init"，輸入 [ init | checkbox ]
	 * @param {boolean} value - checkbox更改為 [ true | false ]
	 * @param {Object} checkbox - input[type="checkbox"] DOM (JS)
	 * @param {Object} $parent - 產品列表物件DOM (<li>) (JQ)
	 * @param {Object} $label - Label DOM (與checkbox同層級的物件) (JQ)
	 */
	var compareCheckedChange = function(status = 'init', value, checkbox, $parent, $label, $labelTip) {
		if(value) {
			/* 加入 */
			$parent.addClass(comparedWrapperClassIsAdded);

			var labelTextData = compareCheckboxLabelTextGet(true);
			$label.text(labelTextData.label);
			$labelTip.text(labelTextData.tip);

			if(status === 'checkbox') {
				var data = compareItemDataGet(checkbox, $parent);
				var $navEl = compareNavAddDom(data);

				data.$navEl = $navEl;
				compareArray.push(data);

				/* 0 -> 1 狀態 => 設定Group資料 */
				if(compareArray.length === 1 && $parent.get(0).groupInfo !== undefined) {
					var groupInfo = $parent.get(0).groupInfo;
					compareCurrentGroup = groupInfo.name;
					$compareCurrentGroupEl = groupInfo.$el;

					compareReInit = true;
				}

				/* 更改比較清單的狀態 */
				/* （取消要等到執行compareRemove後才可進行，所以移到compareRemove內） */
				compareNavChangeStatus(compareArray.length);
			} else if (status === 'init') {
				/* Init時，更改狀態 */
				checkbox.checked = true
			}

		} else {
			/* 取消 */
			compareRemove(compareItemDataGet(checkbox));
		}
	}

	/* 取得/紀錄Checkbox資料 */
	var compareItemDataGet = function(checkbox, $parent, $navEl) {
		if(checkbox.compareOption === undefined) {
			var productImg = $parent.find('[data-product-img]');
			var link = $parent.find('.button');
			var bg = productImg.attr('data-src') || productImg.attr('src')
			var data = {
				/* 刪除需要 */
				$parent: $parent,
				$navEl: $navEl || null,
				id: $parent.attr('data-product-id'),
				checkbox: checkbox,

				/* 建立DOM需要 */
				img: bg,
				sku: $parent.find('.display-sku').text(),
				href: link.attr('href'),
				title: link.attr('title'),
				value: checkbox.value,
			};

			/* IE 會有圖片放置於background的情況 */
			if(bg.match(/1x1.gif/g)) {
				bg = productImg.css('background-image').replace(/.*\s?url\([\'\"]?/, '').replace(/[\'\"]?\).*/, '')
				data.img = bg
			}

			checkbox.compareOption = data;
		}
		return checkbox.compareOption
	}

	/* 增加DOM & 設定刪除按鈕事件 */
	var compareNavAddDom = function(data) {
		var elHtml = `<li class="compare-nav__item" data-product-id="${data.id}">
			<a class="compare-nav__link offset-outer" href="${data.href}" title="${data.title} [另開新視窗]" target="_blank">
				<div class="compare-nav__img-box object-fit-contain product" style="background-image: url(${data.img})"></div>${data.sku}
			</a>
			<button class="compare-nav__del" type="button" aria-label="刪除" title="刪除" data-compare-del><span class="close-button"></span></button>
			<input type="hidden" name="compare[]" value="${data.value}" />
		</li> `

		var $el = $(elHtml);
		compareDelSet($el, data);

		$compareNav.append($el);

		return $el
	}

	/* 更改比較選單的狀態 */
	/* 1. 0 時 => 取消所有Disabled、恢復所有預設值 */
	var compareNavChangeStatus = function(length) {
		if(length === 0) {
			$compareNavWrapper.addClass(compareNavClassHide);

			compareCurrentGroup = '';
			$compareCurrentGroupEl = null;

			/* 取消所有Disable */
			$compareGroup.each(function(index, item) {
				var $group = $(item),
					$pdListItems = $group.find('[data-product-id]').not('[data-compare="false"]');
	
				$pdListItems.each(function(i, el) {
					var $parent = $(el),
						$checkbox = $parent.find('input[type="checkbox"]'),
						checkbox = $checkbox.get(0),
						$label = $checkbox.siblings('label'),
						$labelTip = $parent.find('.compare-checkbox__tip-text');
						
					var labelTextData = compareCheckboxLabelTextGet(false);

					checkbox.disabled = false;
					$label.text(labelTextData.label);
					$labelTip.text(labelTextData.tip);
				});
			});
		} else {
			if(length === 1) {
				$compareNavBtnSubmit.attr('disabled', true);
				$compareNavBtnWrapper.addClass(compareNavBtnClassHide);

				/* 0 -> 1 狀態 => Group重新設定 */
				if(compareReInit) {
					compareReInit = false;
					compareInitList();
				}
			} else {
				$compareNavBtnSubmit.attr('disabled', false);
				$compareNavBtnWrapper.removeClass(compareNavBtnClassHide);
			}

			/* 處理最大值 */
			if(length === compareMax) {
				compareMaxSwitchHandler(true);
			} else if(length === compareMax - 1) {
				compareMaxSwitchHandler(false);
			}

			$compareNavNum.text(length);
			$compareNavWrapper.removeClass(compareNavClassHide);
		}
	}

	/* 最大值 & 非最大值狀態改變 */
	var compareMaxSwitchHandler = function(isMax) {
		if($compareCurrentGroupEl !== undefined && $compareCurrentGroupEl !== null) {
			var $pdListItems = $compareCurrentGroupEl;
			var labelTextData = isMax ? compareCheckboxLabelTextGet(null, true) : compareCheckboxLabelTextGet(false);
			[].forEach.call($pdListItems, function($el) {
				var $parent = $el,
					$checkbox = $parent.find('input[type="checkbox"]'),
					checkbox = $checkbox.get(0),
					$label = $checkbox.siblings('label'),
					$labelTip = $parent.find('.compare-checkbox__tip-text');

				if(checkbox.checked === false) {
					if(isMax) {
						checkbox.disabled = true;
					} else {
						checkbox.disabled = false;
					}
					$label.text(labelTextData.label);
					$labelTip.text(labelTextData.tip);
				}
			});
		}
	}

	/* 移除物件 */
	var compareRemove = function(data, clearAll, callback) {
		var index = compareArray.findIndex(val => val.id === data.id);
		
		/* 移除陣列資料 */
		compareArray.splice(index, 1);

		data.$parent.removeClass(comparedWrapperClassIsAdded);
		if(data.checkbox !== null) {
			/* 因為清除全部時 button[type="reset"] 的功用是重設預設值，導致原本設置checked="true"的物件被重設為true */
			/* 因此清除全部時要跟著清除 Attribute，避免上述情況 */
			var el = data.checkbox;
			el.checked = false;
			if(clearAll) el.removeAttribute('checked');
		}
		if(data.$navEl !== undefined && data.$navEl !== null) data.$navEl.remove();

		/* 更改比較清單的狀態 */
		if(clearAll !== true) compareNavChangeStatus(compareArray.length);

		/* Callback */
		if(typeof callback === 'function') callback();
	}

	/* 比較選單 - 刪除按鈕按下事件 */
	var compareDelBtnClickHandler = function(e) {
		compareRemove(this.compareOption);

		/* 移除Panel的開啟 */
		if(compareArray.length === 0) {
			if(window.innerWidth < 1024) docEnableScroll();
			$compareNavWrapper.removeClass('is-open');
			$compareNavWrapper.children('[data-panel]').removeClass('is-open');
		}
	}

	/* 比較選單 - 刪除按鈕事件綁定 */
	var compareDelSet = function($el, data) {
		var $del = $el.find('[data-compare-del]');
		$del.get(0).compareOption = data; // 設定資料
		$del.on('click', compareDelBtnClickHandler); // 綁定click事件
	}

	/* Init */
	var compareInit = function () {
		/* 將所有頁面上的產品先製作快取分類 */
		compareInitCache();

		/* 無法比較的物件 */
		compareFalseInit();
		
		/* 處理：比較選單 */
		/* 確認是否已有比較項目(Group名稱) */
		compareCurrentGroup = $compareNav.attr('data-compare-nav') || '';

		if(compareCurrentGroup !== '') {
			var $compareList = $compareNav.children('li');

			/* 確認有幾項 => 推上Array */
			$compareList.each(function(index, el) {
				var $self = $(el);
				var data = {
					$navEl: $self, // 比較選單列表物件DOM，刪除用
					id: $self.attr('data-product-id') // 尋找列表同物件用
				}

				/* 確認物件是否有在頁面上 */
				var $item = $compareGroup.find('[data-product-id="' + data.id + '"]');
				var item = $item.get(0);
				var checkbox = item !== undefined ? item.querySelector('input[type="checkbox"]') : null;
				
				data.$parent = $item || null; // 取得列表上的物件使用

				/* 紀錄Checkbox DOM(確認物件是否有在頁面上 ? 有則紀錄DOM : 沒有則空值) */
				/* 取消checkbox用 */
				data.checkbox = checkbox;

				/* --- */
				/* Data 完成 */
				/* 資料紀錄在checkbox */
				if(checkbox !== null) compareItemDataGet(checkbox, $item, $self);
				
				/* 刪除按鈕 */
				compareDelSet($self, data);

				/* 推上記錄 */
				compareArray.push(data);
			});

			compareNavChangeStatus(compareArray.length);
		} else {
			/* 清除內容 */
			$compareNav.html('');
		}

		/* ------------------------------------------------- */
		/* 處理：列表 */
		compareInitList('init');

		/* ------------------------------------------------- */
		/* 清除所有綁定 */
		$('[data-compare-del-all]').on('click', function() {
			var len = compareArray.length;
			for(var i = 0; i < len; i++) {
				var data = compareArray[0];
				if(i === len - 1) {
					/* Last */
					compareRemove(data, true, function () {
						compareNavChangeStatus(0);
					});
				} else {
					compareRemove(data, true);
				}
			}
		});
	}

	/* 處理：分類頁面上的所有產品 */
	var compareInitCache = function() {
		$productItem.each(function(index, el) {
			var $self = $(el);
			var groupName = $self.data('product-group');
			if(compareGroupCache[groupName] === undefined) {
				compareGroupCache[groupName] = [];
			}
			compareGroupCache[groupName].push($self);
		});
	}

	var compareFalseInit = function() {
		$productItemCompareFalse.each(function(index, el) {
			var $el = $(el),
				$checkbox = $el.find('input[type="checkbox"]'),
				$label = $checkbox.siblings('label'),
				$labelTip = $el.find('.compare-checkbox__tip-text'),
				labelTipText = $el.data('compareTip') || '無規格資訊列表';

			$checkbox.attr('disabled', true);
			$label.text('無法比較');
			$labelTip.text(labelTipText);
		});
	}

	/* 處理：是否在比較列表內 */
	var comparePdItemCheckInList = function($el) {
		return compareArray.some(val => val.id === $el.attr('data-product-id'));
	}

	/* 處理：列表 */
	var compareInitList = function (type) {
		Object.keys(compareGroupCache).map(function(key, index) {
			var pdListItems = compareGroupCache[key],
				groupName = key;

			/* 確認是否是目前正比較的Group */
			var theSameGroup = compareCurrentGroup !== '' && compareCurrentGroup === groupName;
			if(theSameGroup) $compareCurrentGroupEl = pdListItems;

			/* 取得Label文字 */
			var labelTextData = theSameGroup
				? compareCheckboxLabelTextGet(null, true)
				: compareCheckboxLabelTextGet(null);

			[].forEach.call(pdListItems, function($el, i) {
				var el = $el.get(0);
				var $parent = $el,
					$checkbox = $parent.find('input[type="checkbox"]'),
					checkbox = $checkbox.get(0),
					$label = $checkbox.siblings('label'),
					$labelTip = $parent.find('.compare-checkbox__tip-text');
				
				/* 紀錄Group資料 */
				if(el.groupInfo === undefined) {
					el.groupInfo = {
						name: groupName,
						$el: pdListItems
					}
				}

				/* 更改<label>文字
				 * 1. 如果已有比較清單，不同Group => 顯示'無法比較'，註解為'非同類型無法比較'
				 * 2. 如果已有比較清單，同Group，checked => 顯示'已加入比較'，註解為'至多選擇 4 個產品進行比較'
				 * 3. 如果已有比較清單，同Group，數量達4個，非checked => 顯示'無法比較'，註解為'比較數量已達上限'
				 */
				if (compareCurrentGroup !== '') {
					/* 如果已有比較清單 */
					if(compareCurrentGroup !== groupName && 'group-' + compareCurrentGroup !== groupName) {
						/* 不同Group */
						checkbox.disabled = true;
						// var labelTextData = compareCheckboxLabelTextGet(null);
						$label.text(labelTextData.label);
						$labelTip.text(labelTextData.tip);
					} else if(comparePdItemCheckInList($el)) {
						/* 同Group && 是checked物件(在比較選單內) */
						compareCheckedChange('init', true, checkbox, $parent, $label, $labelTip);
					} else if(compareArray.length === 4) {
						/* 同Group && 非checked物件 && 比較數量到達4個 */
						checkbox.disabled = true;
						// var labelTextData = compareCheckboxLabelTextGet(null, true);
						$label.text(labelTextData.label);
						$labelTip.text(labelTextData.tip);
					}
				}

				/* Init才設定Change事件 */
				if(type === 'init') {
					$checkbox.on('change', function (event) {
						var target = event.target;
						compareCheckedChange('checkbox', target.checked, target, $parent, $label, $labelTip);
					});
				}
			});
		});
	}
	registerListener('load', compareInit);



	/* ------------------------------------------------- [START] Compare Panel開啟關閉（平板） */
	/* Compare Panel開啟關閉（平板） */
	var $doc = $(document);
	var comparePanel = $compareNavWrapper.children('[data-panel]');
	var comparePanelOpenBtn = $compareNavWrapper.children('[data-panel-open]');
	var comparePanelCloseBtn = $compareNavWrapper.find('[data-panel-close]');
	var comparePanelTimer = null;

	var comparePanelCloseHandler = function () {
		if(comparePanelTimer !== null) clearTimeout(comparePanelTimer);
		comparePanelTimer = setTimeout( function() {
			comparePanelTimer = null;
			if(window.innerWidth < 1024) {
				docEnableScroll();
			}
			$compareNavWrapper.removeClass('is-open');
			comparePanel.removeClass('is-open');
			comparePanelClickOffHandler();
		}, 100);
	}

	/* ------------------------------------------- [START] >= 640 && < 1024 */
	/* 點擊空白處會關閉 */
	var comparePanelClickHandler = function(e) {
		if(event.target === this) comparePanelCloseHandler();
	}

	var comparePanelOpenHandler = function() {
		comparePanel.on('touchstart', comparePanelClickHandler);
	}

	var comparePanelClickOffHandler = function() {
		comparePanel.off('touchstart', comparePanelClickHandler);
	}

	/* ---- */
	/* Init */
	var comparePanelTabletInit = function() {
		comparePanelOpenBtn.on('click', comparePanelOpenHandler);
		comparePanelCloseBtn.on('click', comparePanelClickOffHandler);
	}

	/* Destroy */
	var comparePanelTabletDestroy = function() {
		comparePanelOpenBtn.off('click', comparePanelOpenHandler);
		comparePanelCloseBtn.off('click', comparePanelClickOffHandler);
	}
	/* ---- */
	/* Breakpoint */
	var comparePanel__breakpointMin = window.matchMedia('(min-width: 640px)');
	var comparePanel__breakpointMax = window.matchMedia('(max-width: 1023px)');
	var comparePanel__breakpointChecker = function () {
		if(comparePanel__breakpointMin.matches && comparePanel__breakpointMax.matches) {
			/* 640 ~ 1023 */
			comparePanelTabletInit();
		} else {
			comparePanelTabletDestroy();
		}
	}
	registerListener('load', comparePanel__breakpointChecker);
	comparePanel__breakpointMin.addListener(comparePanel__breakpointChecker);
	comparePanel__breakpointMax.addListener(comparePanel__breakpointChecker);
	/* ------------------------------------------- [END] >= 640 && < 1024 */


	/* ------------------------------------------- [START] > 1024 */
	/* Plugin */
	/* Ref: https://stackoverflow.com/a/3028037/11240898 */
	function hideOnClickOutside(element, callback, eventType) {
		eventType = eventType || 'click';
		let build = false;
		const outsideClickListener = event => {
			if (!element.contains(event.target) && isVisible(element)) { // or use: event.target.closest(selector) === null
				if(typeof callback === 'function') callback();
				removeClickListener()
			}
		}
	
		const removeClickListener = () => {
			build = false;
			document.removeEventListener(eventType, outsideClickListener)
		}

		const buildClickListener = () => {
			if(!build) {
				build = true;
				document.addEventListener(eventType, outsideClickListener)
			}
		}

		buildClickListener();

		return {
			remove: removeClickListener,
			rebuild: buildClickListener
		}
	}
	const isVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	/* source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js */

	/* ----------- */
	/* Large Tablet */
	var comparePanelDocClickEvent = undefined;

	var comparePanelLargeTabletOpenHandler = function () {
		if(comparePanel.hasClass('is-open')){
			if(comparePanelDocClickEvent !== undefined) comparePanelDocClickEvent.rebuild();
			else comparePanelDocClickEvent = hideOnClickOutside(document.getElementById('compare-nav-wrapper'), comparePanelCloseHandler, 'touchstart');
		} else {
			comparePanelLargeTabletClickOffHandler();
		}
	}

	var comparePanelLargeTabletClickOffHandler = function () {
		if(comparePanelDocClickEvent !== undefined) comparePanelDocClickEvent.remove();
	}
	/* ---- */
	/* Init */
	var comparePanelLargeTabletInit = function() {
		comparePanelOpenBtn.on('click', comparePanelLargeTabletOpenHandler);
		comparePanelCloseBtn.on('click', comparePanelLargeTabletClickOffHandler);
	}

	/* Destroy */
	var comparePanelLargeTabletDestroy = function() {
		comparePanelOpenBtn.off('click', comparePanelLargeTabletOpenHandler);
		comparePanelCloseBtn.off('click', comparePanelLargeTabletClickOffHandler);
	}
	/* ---- */
	/* Breakpoint */
	var comparePanelLargeTablet__breakpoint = window.matchMedia('(min-width: 1024px)');
	var comparePanelLargeTablet__breakpointChecker = function () {
		if(comparePanelLargeTablet__breakpoint.matches && isMobile) {
			comparePanelLargeTabletInit();
		} else {
			comparePanelLargeTabletDestroy();
		}
	}
	registerListener('load', comparePanelLargeTablet__breakpointChecker);
	comparePanelLargeTablet__breakpoint.addListener(comparePanelLargeTablet__breakpointChecker);
	/* ------------------------------------------- [END] > 1024 */


	/* Other */
	comparePanelOpenBtn.on('click', function () {
		$(this).blur();
	});

	/* ------------------------------------------------- [END] Compare Panel開啟關閉（平板） */



	/* ------------------------------------------------- [START] Mobile點擊顯示資訊 */
	/* Mobile點擊顯示資訊 */
	var $InfoOpen = $('[data-info-open]');
	var infoClassOpen = 'is-open';
	var infoDocDetected = false;
	var currentInfoTarget = null;
	$InfoOpen.on('click', function() {
		var $self = $(this);
		if($self.hasClass(infoClassOpen)) {
			infoDocClickRemoveEvent();
		} else {
			currentInfoTarget = this;
			$InfoOpen.removeClass(infoClassOpen);
			$self.addClass(infoClassOpen);
			if(!infoDocDetected) {
				infoDocDetected = true;
				document.addEventListener('touchstart', infoDocClickDetectHandler, {passive: true});
			}
		}
	});

	/* 移除doc touchstart事件 */
	var infoDocClickRemoveEvent = function () {
		$(currentInfoTarget).removeClass(infoClassOpen);
		document.removeEventListener('touchstart', infoDocClickDetectHandler);
		currentInfoTarget = null;
		infoDocDetected = false;
	}

	/* doc touchstart事件 */
	var infoDocClickDetectHandler = function (e) {
		e = e || window.event;
		var target = e.target || e.srcElement;
		if(target !== currentInfoTarget && currentInfoTarget !== null) {
			infoDocClickRemoveEvent();
		}
	}
	/* ------------------------------------------------- [END] Mobile點擊顯示資訊 */
})(window, document);
